<template>
    <router-link :to="to" class="kb-back">
        ← <slot />
    </router-link>
</template>

<script>
export default {
    name: 'kb-back',
    props: {
        to: {type: Object, required: true},
    },
};
</script>

<style lang="scss" scoped>
.kb-back {
    display: inline-block;
    font-size: 0.9rem;
    color: #666;
    margin-bottom: 8px;

    &:hover {
        color: #000;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/pages/knowledge-base/kb-back.vue